import React from "react";
import Icon from '@ant-design/icons';
import { Button, Col, Divider, Input, Row } from "antd";
import AuthDialogWidget from "components/AuthDialogWidget/AuthDialogWidget";
import AuthLogoWidget from "components/AuthLogoWidget/AuthLogoWidget";
import NormalButton from "components/ButtonWidgets/NormalButton/NormalButton";
import TextButton from "components/ButtonWidgets/TextButton/TextButton";
import CodeVerificationWidget from "components/CodeVerificationWidget/CodeVerificationWidget";
import InputEmailOrPhone from "components/InputWidgets/InputEmailOrPhone/InputEmailOrPhone";
import InputPassword from "components/InputWidgets/InputPassword/InputPassword";
import { useState } from "react";
import { withRouter } from "react-router";
import "./ForgotPasswordPage.css";
import { ReactComponent as emailIcon } from '../../assets/icons/ic_envelope.svg';
import { ValidateEmail } from "utils/GlobalFunctions";
import ReactCodeInput from "react-code-input";
function InputPage(props) {
  const { userDetail, setUserDetail, isBusy, registrationInfo, step, setStep } = props;
  const { onClickLogin, onSubmit } = props;
  const [wrongList, setWrongList] = useState([]);
  const [isWrong, setIsWrong] = useState(false);
  const [code, setCode] = useState("");

  const validateFields = () => {
    const { email, code, password, confirm_password } = userDetail;
    let tmpWrongList = [];
    if (step == 0) {
      if (email === undefined || email === "") {
        tmpWrongList.push("email");
      } else {
        if (ValidateEmail(email) === false) {
          tmpWrongList.push("email");
        }
      }
    } else if (step == 1) {
      if (code.length !== 8) {
        tmpWrongList.push("code");
      }
    } else if (step == 2) {
      if (password === undefined || password === "") {
        tmpWrongList.push("password");
      }
      if (confirm_password === undefined || confirm_password === "") {
        tmpWrongList.push("confirm_password");
      }
      if (password != confirm_password) {
        tmpWrongList.push("confirm_password");
      }
    }
    setWrongList(tmpWrongList);
    return tmpWrongList.length === 0;
  };

  const onClickNext = () => {
    if (validateFields() === false) {
      return;
    }
    onSubmit();
  };

  const onChangeCode = (value) => {
    if (wrongList.includes("code")) {
      let tmpList = [...wrongList]
      setWrongList(tmpList.filter((x) => x !== "code"))
    }
    setUserDetail({ ...userDetail, code: value })
  };
  return (
    <div className="main-background-rect" style={{ background: "#ffffff" }}>
      <div style={{ background: "#ffffff", textAlign: 'center', width: '600px', margin: 'auto' }} className="logo-rects">
        <AuthDialogWidget title={registrationInfo?.homepage_title} top={70} registrationInfo={registrationInfo}>
          <div className="email-input" style={{ paddingLeft: 50, paddingRight: 50, marginTop: 15 }}>
            <p style={{ fontSize: 18 }}>Forgot your password?</p>
            {step == 0 && <>
              <p>Enter your email so that we can send you password reset link</p>
              <Input
                type="text"
                prefix={<Icon component={emailIcon} className="menu-item-icon" />}
                suffix={""}
                placeholder="Email"
                value={userDetail.email === undefined ? "" : userDetail.email}
                onChange={(e) => {
                  if (wrongList.includes("email")) {
                    let tmpList = [...wrongList]
                    setWrongList(tmpList.filter((x) => x !== "email"))
                  }
                  setUserDetail({ ...userDetail, email: e.target.value })
                }
                }
                style={{
                  border:
                    wrongList.includes("email") === true
                      ? "1px solid var(--redColor)"
                      : "1px solid var(--greyColor)",
                }}
              />
            </>}
            {step == 1 && <>
              <p>Enter the 8 digit verification code sent to the provided email address.</p>
              <ReactCodeInput
                value={userDetail.code}
                isValid={!wrongList.includes("code")}
                fields={8}
                onChange={onChangeCode}
              />
            </>}
          </div>
          {step == 2 && <>
            <p>Enter New Password</p>
            <div className="pass-input" style={{ paddingLeft: 50, paddingRight: 50, marginTop: 15 }}>
              <InputPassword
                field={"password"}
                userDetail={userDetail}
                setUserDetail={setUserDetail}
                wrongList={wrongList}
                setWrongList={setWrongList}
                placeholder={"Password"}
              />
            </div>
            <div className="pass-input" style={{ paddingLeft: 50, paddingRight: 50, marginTop: 15 }}>
              <InputPassword
                field={"confirm_password"}
                userDetail={userDetail}
                setUserDetail={setUserDetail}
                wrongList={wrongList}
                setWrongList={setWrongList}
                placeholder={"Confirm Password"}
                type={"login"}
              />
            </div>
          </>}
          <div style={{ marginTop: 15, paddingLeft: 50, paddingRight: 50 }}>
            <NormalButton
              style={{ backgroundColor: "#7fb522" }}
              onClick={onClickNext}
              isBusy={isBusy}
            >
              {step == 0 && <>Send Email</>}
              {step == 1 && <>Verify Code</>}
              {step == 2 && <>Change Password</>}
            </NormalButton>
          </div>
          <div style={{ textAlign: "center", marginTop: 25, paddingLeft: 20, paddingRight: 20 }}>
            <TextButton
              onClick={onClickLogin}
              style={{ color: '#8abb37' }}
            >
              Login
            </TextButton>
          </div>
        </AuthDialogWidget>
      </div>
    </div >
  );
}

export default withRouter(InputPage);
